import * as i0 from "@angular/core";
var UuidService = /** @class */ (function () {
    function UuidService() {
    }
    UuidService.prototype.generateUUID = function () {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
            return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
    };
    UuidService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UuidService_Factory() { return new UuidService(); }, token: UuidService, providedIn: "root" });
    return UuidService;
}());
export { UuidService };
